import { Box, chakra, Text } from '@chakra-ui/react'
import React from 'react'
import { CollectionType } from '../../../types/collections'
import { BriddgyImage } from '../../Misc/GatsbyImage'
import { LinkOverlay } from '../../Misc/LinkOverlay'


export const CollectionBox = chakra(({className,collection}:{className?:any,collection:CollectionType})=>{
    return(
        <Box className="tag-gotocollectionPage" _hover={{boxShadow:"elevation_5"}} transition='.3s ease' cursor='pointer' overflow='hidden' minH={["14rem","16rem","20rem"]}  className={className} borderRadius='base' pos='relative' >
            <Box  w='100%' h='100%' pos='absolute' top='0' left='0'  transition='.3s ease'>
                <BriddgyImage fit="cover" h='100%' w='100%' image={collection.image?.gatsbyImageData} alt={collection.image?.altText}/>
                
            </Box>
            
            <LinkOverlay  _before={{bgGradient:"linear(180deg,transparent 50%,black )",opacity: "0.9"}}  _hover={{_before:{ opacity: "1"}}}  to={`/shop/category/${collection.slug}`}>
                <Text zIndex={1} color='white' p={4} pos='absolute' bottom="1rem" fontSize={[700,700,'hb1']} fontWeight='700' as='h3'>
                    {collection.title}
                </Text>
            </LinkOverlay>
        </Box>
    )
})